import PropTypes from 'prop-types';
import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { NotificationMethodCheckbox } from './NotificationMethodCheckbox';
import { NotificationTypeGridMessages as messages } from './NotificationTypeGrid.i18n';

class NotificationTypeRowInternal extends React.Component {
  getReminderOffset = () => {
    if (this.props.reminderOffset === null || this.props.reminderOffset === undefined) {
      return '';
    }
    return this.props.reminderOffset;
  }

  handleOnChange = (event) => {
    this.props.onInputChange(event.target.name, event.target.value);
  };

  renderTooltip = (config) => {
    const tooltip = (
      <Tooltip id={config.id} role="tooltip">{config.label}</Tooltip>
    );
    return (
      <OverlayTrigger placement="top" overlay={tooltip}>
        <a type="button" className="text-info ml-1" data-toggle={config.id}>
          <span className={config.iconClass} aria-hidden="true"></span>
        </a>
      </OverlayTrigger>
    );
  }

  renderInfoIcon = () => {
    if (this.props.info) {
      const config = {
        id: `info-tooltip-${this.props.typeLabel.replace(' ', '-')}`,
        label: this.props.info,
        iconClass: 'fa fa-info-circle',
      };
      return this.renderTooltip(config);
    }
    return null;
  }

  render = () => (
    <tr>
      <td className="middle bold">
        {this.props.typeLabel}
        {this.renderInfoIcon()}
      </td>
      <td>
        {
          this.props.isEmailEnabled ?
            <NotificationMethodCheckbox
              name={this.props.emailProperty}
              ariaCheckboxLabel={this.props.intl.formatMessage(messages.notificationTypeRow.emailAriaLabel)}
              checkboxLabel={this.props.intl.formatMessage(messages.notificationTypeRow.emailLabel)}
              isChecked={this.props.isEmailChecked}
              onChange={this.props.onInputChange}
            />
          : null
        }
      </td>
      <td>
        {
          this.props.isSmsEnabled ?
            <NotificationMethodCheckbox
              name={this.props.smsProperty}
              ariaCheckboxLabel={this.props.intl.formatMessage(messages.notificationTypeRow.smsAriaLabel)}
              checkboxLabel={this.props.intl.formatMessage(messages.notificationTypeRow.smsLabel)}
              isChecked={this.props.isSmsChecked}
              onChange={this.props.onInputChange}
              isReadOnly={this.props.isSmsCheckboxReadOnly}
            />
          : null
        }
      </td>
    </tr>
  )
}

NotificationTypeRowInternal.propTypes = {
  intl: PropTypes.object.isRequired,
  emailProperty: PropTypes.string.isRequired,
  smsProperty: PropTypes.string.isRequired,
  typeLabel: PropTypes.string.isRequired,
  isEmailEnabled: PropTypes.bool,
  isSmsEnabled: PropTypes.bool,
  isEmailChecked: PropTypes.bool,
  isSmsChecked: PropTypes.bool,
  onInputChange: PropTypes.func,
  isSmsCheckboxReadOnly: PropTypes.bool,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export const NotificationTypeRow = NotificationTypeRowInternal;